import {motion} from "framer-motion";
import styles from './Menu.module.css';

// Menu Data
const menuItems = [
    {
        title: "Sushi Menu",
        img: "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681b96912fe162c63ba9238a_Food%20Image.png",
        btnBg: "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681bbccdcb4a2b5172a29013_Button%20Solid.svg",
        link: "/menu",
    },
    {
        title: "Drinks Menu",
        img: "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681b9691ddcbad341d1a6c75_Drinks%20Image.png",
        btnBg: "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681bbccdcb4a2b5172a29013_Button%20Solid.svg",
        link: "/menu#beverages",
    },
];

export default function Menu() {
    return (
        <section className={styles.menuSection}>
            <div className={styles.container}>
                {/* Top-left Title */}
                <h2 className={styles.menuTitle}>
                    Menu
                </h2>
                {/* 2 Huge Cards */}
                <div className={styles.menuCardsContainer}>
                    {menuItems.map((item, idx) => (
                        <motion.div
                            key={item.title}
                            initial={{scale: 0.9, opacity: 0}}
                            whileInView={{scale: 1, opacity: 1}}
                            viewport={{once: true}}
                            transition={{duration: 0.7, delay: idx * 0.14, ease: [0.23, 1, 0.32, 1]}}
                            className={styles.menuCard}
                            style={{
                                minWidth: 0,
                            }}
                        >
                            {/* Menu Button (Top-Right) */}
                            <a
                                href={item.link}
                                className={styles.menuButton}
                                style={{minWidth: 182, minHeight: 62, display: 'inline-block'}}
                            >
                                <img
                                    src={item.btnBg}
                                    alt=""
                                    className={styles.menuButtonBg}
                                    draggable={false}
                                    style={{minWidth: 182, minHeight: 62}}
                                />
                                <span
                                    className={styles.menuButtonText}>
                  <span className={styles.menuButtonTextInner}>
                    {item.title}
                      <span
                          className={styles.menuButtonUnderline}></span>
                  </span>
                </span>
                            </a>
                            {/* Full-bleed image */}
                            <img
                                src={item.img}
                                alt=""
                                className={styles.menuImage}
                                style={{
                                    minHeight: "420px",
                                    maxHeight: "850px",
                                    minWidth: "100%",
                                }}
                                loading="lazy"
                                draggable={false}
                            />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}